const DriveDark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clipPath="url(#clip0_2695_40321)">
      <path
        d="M9.46 3.005C9.36 2.71 9.08 2.5 8.75 2.5H3.25C2.92 2.5 2.645 2.71 2.54 3.005L1.555 5.84C1.52 5.945 1.5 6.055 1.5 6.17V9.75C1.5 10.165 1.835 10.5 2.25 10.5C2.665 10.5 3 10.165 3 9.75V9.5H9V9.75C9 10.16 9.335 10.5 9.75 10.5C10.16 10.5 10.5 10.165 10.5 9.75V6.17C10.5 6.06 10.48 5.945 10.445 5.84L9.46 3.005ZM3.25 8C2.835 8 2.5 7.665 2.5 7.25C2.5 6.835 2.835 6.5 3.25 6.5C3.665 6.5 4 6.835 4 7.25C4 7.665 3.665 8 3.25 8ZM8.75 8C8.335 8 8 7.665 8 7.25C8 6.835 8.335 6.5 8.75 6.5C9.165 6.5 9.5 6.835 9.5 7.25C9.5 7.665 9.165 8 8.75 8ZM2.5 5.5L3.135 3.59C3.205 3.39 3.395 3.25 3.61 3.25H8.39C8.605 3.25 8.795 3.39 8.865 3.59L9.5 5.5H2.5Z"
        fill="#374151"
      />
    </g>
    <defs>
      <clipPath id="clip0_2695_40321">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DriveDark;
